import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { AccceptChangeOrderParams } from "../types/AccceptChangeOrderParams";
import { AccceptChangeOrderResults } from "../types/AccceptChangeOrderResults";

export const useAcceptChangeOrder = (
	onSuccess: (newRetailOrderID: number) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async (params: AccceptChangeOrderParams) => {
			return await apiClient.post("retail-order/accept-change-order", params) as AccceptChangeOrderResults;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result.newRetailOrderID);
			else
				onError('Error when accepting change order: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
